module.exports = "/assets/about/success/forum.png?vDU1scR";